import Vue from 'vue';

export function setPage(state, value) {
  state.page = value;
}
export function setAnswer(state, payload) {
  Vue.set(state.answers, payload.index, payload.updates);
}
export function setAnswerMultia(state, payload) {
  let aux = {};
  let all = {};
  let ans = state.answers;
  const ang = ans[payload.index];

  console.log('payload', payload);
  if (!ang) {
    Object.assign(all, ang);
    Object.assign(aux, ang[payload.country]);
  }

  Vue.set(aux, payload.country, payload.answer);
  console.log('aux', aux);
  Object.assign(all[payload.group], aux);
  //Vue.set(all, payload.group, aux)
  console.log('all', all);
  Vue.set(state.answers, payload.index, all);
}
export function setAnswerMulti(state, payload) {
  let aux = {};
  let all = {};

  // Get first existing data
  Object.assign(all, state.answers[payload.index]);
  Object.assign(aux, all[payload.group]);

  // Add new data
  Vue.set(aux, payload.country, payload.answer);
  Vue.set(all, payload.group, aux);
  Vue.set(state.answers, payload.index, all);
}
export function setQuestions(state, questions) {
  Object.assign(state.questions, questions);
}
